import { useEffect } from 'react';
import api from '../../services/api';
import { getImageUrl } from '../../utils/imageUrl';

const DynamicFavicon = () => {
  useEffect(() => {
    updateFavicon();
  }, []);

  const updateFavicon = async () => {
    try {
      const response = await api.get('/settings');
      // Use logoIcon first, fallback to favicon
      const faviconPath = response.data.data?.frontendMedia?.logoIcon || response.data.data?.frontendMedia?.favicon;

      if (faviconPath) {
        const faviconUrl = getImageUrl(faviconPath);

        // Update favicon link
        let favicon = document.querySelector("link[rel~='icon']");
        if (!favicon) {
          favicon = document.createElement('link');
          favicon.rel = 'icon';
          document.head.appendChild(favicon);
        }
        favicon.href = faviconUrl;

        // Update apple-touch-icon
        let appleTouchIcon = document.querySelector("link[rel~='apple-touch-icon']");
        if (!appleTouchIcon) {
          appleTouchIcon = document.createElement('link');
          appleTouchIcon.rel = 'apple-touch-icon';
          document.head.appendChild(appleTouchIcon);
        }
        appleTouchIcon.href = faviconUrl;
      }
    } catch (error) {
      console.error('Error updating favicon:', error);
    }
  };

  return null; // This component doesn't render anything
};

export default DynamicFavicon;
